module.exports = __webpack_public_path__ + "img/person.780b21ae.svg";